import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'Confirmați adresa de email',
  [OnboardingStep.BusinessInfo]: 'Adăugați detaliile magazinului',
  [OnboardingStep.PersonalInfo]: 'Adăugați informațiile personale',
  [OnboardingStep.ShippingInfo]: 'Adăugați informațiile de livrare',
  [OnboardingStep.BankInfo]: 'Adăugați datele bancare pentru plăți',
  [OnboardingStep.TaxInfo]: 'Afacerea dvs. este înregistrată în scopuri de TVA?',
  [OnboardingStep.BusinessDocs]: 'Document doveditor al afacerii',
  [OnboardingStep.PersonalDocs]: 'Document de identitate',
  [OnboardingStep.InfoSubmission]: 'Primiți plăți',
  confirm_info_gateway: 'Primiți plăți – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Informații de plată',
  [OnboardingStep.Subscription]: 'Abonament',
  [OnboardingStep.MobileApp]: 'Aplicație mobilă',
  [OnboardingStep.DeliveryStructure]: 'Structura livrării',
  [OnboardingStep.Contract]: 'Contract',
  [OnboardingStep.ContractPayment]: 'Plată contract',
  [OnboardingStep.PromoCode]: 'Cod promoțional',
};
